import { forwardRef, useEffect, useImperativeHandle, useState } from "react"
import { Modal, Box, Button, Alert } from "@mui/material"
import { useApiService } from "../../hooks/Api/useApiService"
import styles from "../Modals.module.css"
import ModalCloseButton from "../ModalCloseButton"
import "react-datepicker/dist/react-datepicker.css"
import T from "../../hooks/Language/T"
import useTranslationSharie from "../../hooks/Language/useTranslation"
import TextField from "../../UI/TextField"
import useError from "../../hooks/Error/useError"
import { useSocket } from "../../hooks/Utils/Socket/SocketManager"

const NewDemandModal = forwardRef((props, ref) => {
  useImperativeHandle(ref, () => ({
    childFunction() {
      handleOpen()
    },
  }))

  const [open, setOpen] = useState(false)
  const [form_data, setFormData] = useState({})
  const [severity, setSeverity] = useState("error")
  const [skill_update, setSkillUpdate] = useState({})
  const { postData } = useApiService()
  const t = useTranslationSharie()
  const { Error: AlertError, error, success } = useError()
  const socket = useSocket()
  const handleOpen = () => setOpen(true)
  const handleClose = () => {
    localStorage.setItem("new_demand", JSON.stringify({ ...form_data }))
    setOpen(false)
  }

  useEffect(() => {
    const savedSkill = JSON.parse(localStorage.getItem("new_demand"))
    setFormData(savedSkill || {})
    if (props.mode === "update") {
      setSkillUpdate({ ...props.skill })
    }
  }, [props.mode, props.skill])
  const handleUpdateDemand = async () => {
    if (skill_update.description.length > 500) {
      error("Description is maximum 500 characters")

      return
    }

    const sentData = {
      ...skill_update,
      user_name: localStorage.getItem("user"),
      oldname: props.skill.name,
    }

    if (skill_update.name && skill_update.description) {
      postData("skills/updatedemand", sentData)
        .then((data) => {
          props.setShouldFetch(true)
          setTimeout(() => {
            props.setShouldFetch(false)
          }, 1000)

          if (data.message === "Failed") {
            error("No Changes Were Made...")
          } else {
            success("Updated Demand Successfully!")
          }
        })
        .catch((error) => {
          error(error.message || "An error occurred while updating demand")
        })
    } else {
      error("You Must Fill All Fields")
    }
  }
  const handlePostDemand = async () => {
    if (form_data.name && form_data.description) {
      if (form_data.description.length > 500) {
        error("Description is maximum 500 characters")

        return
      }

      const sentData = {
        ...form_data,
        user_name: localStorage.getItem("user"),
      }

      postData("skills/postdemand", sentData)
        .then((data) => {
          if (data.message === "Failed") {
            error("Faild To Send New Demand")
          } else if (data.message === "Demand Already Exists") {
            error(data.message)
          } else {
            sendNotification("post demand")
            success("Demand Has Been Added Successfully!")
            setTimeout(() => {
              setFormData({})
              handleClose()
            }, 3000)
          }
        })
        .catch((error) => {
          error(error.message || "An error occurred while posting demand")
        })
    } else {
      error("You Must Fill All Fields")
    }
  }
  const sendNotification = (type) => {
    try {
      socket?.emit("send_notification", {
        toUserId: props.skill.user_id,
        skill_name: props.skill.name,
        from: localStorage.getItem("user"),
        to: props.skill.user_name,
        type: type,
      })
      postData("sharie/addnotification", {
        skill_name: props.skill.name,
        from: localStorage.getItem("user"),
        type: type,
      }).then((data) => {})
    } catch (error) {
      console.error("Error sending notification:", error)
    }
  }
  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby='modal-title'
        aria-describedby='modal-description'
      >
        <T>
          <ModalCloseButton handleClose={handleClose} />

          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              bgcolor: "background.paper",
              borderRadius: 2,
              boxShadow: 24,
              width: { xs: "90%", sm: "500px" },
              maxHeight: "40vh",
              overflowY: "auto",
              p: { xs: 2, sm: 4 },
              display: "flex",
              flexDirection: "column",
              gap: 2,
            }}
          >
            {props.mode === "update" ? (
              <>
                <TextField
                  value={skill_update.name}
                  onChange={(e) => setSkillUpdate({ ...skill_update, name: e.target.value })}
                  label={t("Skill Name")}
                  fullWidth
                />

                <TextField
                  label={t("Description")}
                  multiline
                  rows={6}
                  fullWidth
                  value={skill_update.description}
                  onChange={(e) => setSkillUpdate({ ...skill_update, description: e.target.value })}
                />

                <Button variant='contained' fullWidth onClick={handleUpdateDemand}>
                  Update Demand
                </Button>
                {error && <Alert severity={severity}>{error}</Alert>}
              </>
            ) : (
              <>
                <TextField
                  value={form_data?.name || ""}
                  onChange={(e) => setFormData({ ...form_data, name: e.target.value })}
                  label={t("Skill Name")}
                  fullWidth
                />

                <TextField
                  value={form_data?.description || ""}
                  label={t("Description")}
                  multiline
                  rows={6}
                  fullWidth
                  onChange={(e) => setFormData({ ...form_data, description: e.target.value })}
                />

                <Button variant='contained' fullWidth onClick={handlePostDemand}>
                  Post Demand
                </Button>
                <AlertError />
              </>
            )}
          </Box>
        </T>
      </Modal>
    </div>
  )
})

export default NewDemandModal
